import { BaseDbClass } from "app/business/common/basedbclass";

export class tblUserMaster extends BaseDbClass {
    prefix: string;
    firstName: string;
    middleName: string;
    lastName: string;
    email: string;
    countryCode: string;
    mobile: string;
    age: number;
    gender: string;
    roleIds: number[];
    countryId: string;
    country: string;
    stateId: string;
    state: string;
    cityId: string;
    city: string;
    pincodeId: string;
    pincode: string;
    address: string;
    languages: string[];
    yearOfExperience: number;
    currentRoleId?: number
    status?: number
    isActive: boolean;
    isDeleted: boolean;
    isProfileCompleted?: boolean;
    // languageIds: number[];
    dob?: Date | string;
    profileImage?: string;
    
    // Optional Document Uploads
    aadharCardFile?: any;
    panCardFile?: any;
    highestQualificationFile?: any;
    additionalDocumentFile?: any;

    // Optional Bank Details
    bankName?: string;
    branch?: string;
    accountNumber?: string;
    ifscCode?: string;
    cancelChequeFile?: any;
}
